import { useParams } from 'react-router-dom'
import { useUserProfile } from 'api'
import Card from 'common/Card'
import { UserProfileForm } from './UserProfileForm'
import CircularProgress from '@material-ui/core/CircularProgress'
import { strings } from 'strings'

export function UserProfile() {
  const { userId } = useParams<any>()
  const { userProfile, loading, error } = useUserProfile(userId)

  let content

  if (loading)
    content = (
      <div>
        <CircularProgress size={16} />
      </div>
    )
  else if (error) content = <div>{error.message}</div>
  else if (userProfile) content = <UserProfileForm userProfile={userProfile} />

  return (
    <Card title={strings.userSettings} style={{ overflow: 'auto', paddingBottom: 0 }}>
      {content}
    </Card>
  )
}
